import { forwardRef } from "react";

import { FileUploadProps, FileUploadSubComponents } from "capitalrx-components-2.0/lib/forms/FileUpload/FileUpload";
import { Placeholder } from "capitalrx-components-2.0/lib/forms/FileUpload/Placeholder";
import { RefComponent } from "capitalrx-components-2.0/lib/forms/RefComponent";
import { withSubComponents } from "capitalrx-components-2.0/lib/utilities/withSubComponents";

import { Field } from "./Field";
import { Input } from "./Input";

export const FileUpload = withSubComponents<RefComponent<HTMLDivElement, FileUploadProps>, FileUploadSubComponents>(
  {
    Field,
    Placeholder,
  },
  forwardRef<HTMLDivElement, FileUploadProps>(function FileUpload(props, ref) {
    return <Input {...props} ref={ref} />;
  }),
);
